import { type ObservableValue } from '@amazon/vinyl-observable'
import { marketplace$ } from '@/marketplace'
import type { Maybe } from '@amazon/vinyl-util'
import { CLASSIC_TERRITORIES, isKnownTerritory } from '@/territory'

// Strict membership over the canonical uppercase code — a lowercase or unknown
// code is not classic, matching GH's `isValidMarket` guard.
export function isClassicTerritory(territory: Maybe<string>): boolean {
    return isKnownTerritory(territory) && CLASSIC_TERRITORIES.has(territory)
}

/**
 * Whether the library "Purchased" surface is available in the current market.
 * Mirrors GH's `arePurchasesAvailable = isClassicTerritory(getCurrentMarket())`.
 */
export const arePurchasesAvailable$: ObservableValue<boolean> = marketplace$.map((m) =>
    isClassicTerritory(m?.musicTerritory)
)
